import { render, staticRenderFns } from "./DraggableOrderQuestions.vue?vue&type=template&id=03c79228"
import script from "./DraggableOrderQuestions.vue?vue&type=script&lang=js"
export * from "./DraggableOrderQuestions.vue?vue&type=script&lang=js"
import style0 from "./DraggableOrderQuestions.vue?vue&type=style&index=0&id=03c79228&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports